"use client"

import React, { useMemo, useEffect } from "react"
import { Button } from "@/components/ui/button"

interface ApartmentData {
  集合住宅名: string
  建設場所: string
  設計者: string
  概要: string
}

interface QuizQuestionProps {
  apartmentData: ApartmentData
  allApartments: ApartmentData[]
  onChoice: (choiceName: string) => void
  onChoicesGenerated: (choices: ApartmentData[]) => void
  isAnswered: boolean
}

export function QuizQuestion({
  apartmentData,
  allApartments,
  onChoice,
  onChoicesGenerated,
  isAnswered,
}: QuizQuestionProps) {
  /**
   * ランダム4択を生成
   */
  const choices = useMemo(() => {
    const correct = apartmentData
    const incorrect = allApartments.filter(
      (a) => a.集合住宅名 !== correct.集合住宅名,
    )
    shuffleArray(incorrect)

    const selected = [correct, ...incorrect.slice(0, 3)]
    shuffleArray(selected)
    return selected
  }, [apartmentData, allApartments])

  // 選択肢が生成されるたびに親へ報告
  useEffect(() => {
    onChoicesGenerated(choices)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [choices])

  const handleClick = (choice: ApartmentData) => {
    if (!isAnswered) {
      onChoice(choice.集合住宅名)
    }
  }

  return (
    <div>
      {/* 問題文（概要） */}
      <div className="mb-4">
        <p className="font-semibold">【概要】</p>
        <p>{apartmentData.概要}</p>
      </div>

      {/* 選択肢 */}
      <div className="flex flex-col gap-2">
        {choices.map((c) => (
          <Button
            key={c.集合住宅名}
            variant="outline"
            onClick={() => handleClick(c)}
            disabled={isAnswered}
          >
            {c.集合住宅名}
          </Button>
        ))}
      </div>
    </div>
  )
}

/** シャッフル関数 */
function shuffleArray<T>(arr: T[]) {
  for (let i = arr.length - 1; i > 0; i--) {
    const rand = Math.floor(Math.random() * (i + 1))
    ;[arr[i], arr[rand]] = [arr[rand], arr[i]]
  }
}
